import { ID_REGEX } from 'constants/RegExs'

export const replaceIds = (transaction: string) => transaction.replace(ID_REGEX, 'id')
